// @flow
// @ts-ignore
import { CONFIG_CONST } from '../../../../w-config/constants.js';
/**
 * The default server URL to open if no other was specified.
 */
export const DEFAULT_SERVER_HOST = CONFIG_CONST.DEFAULT_SERVER_HOST;
export const DEFAULT_SERVER_URL = `https://${DEFAULT_SERVER_HOST}`;
